(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nv-ar-volume-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nv-ar-volume-default')) {
    customElements.define('nv-ar-volume-default', class extends HTMLElement {
      async connectedCallback() {
        if (document.readyState === 'loading') {
          await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
        }
        await customElements.whenDefined('variant-picker');
        if (!this.isConnected) return;
        const query = new URLSearchParams(location.search);
        if (query.has('variant') || query.has('option_values')) return;
        const picker = this.closest('variant-picker');
        const form = document.getElementById(picker?.getAttribute('form-id'));
        if (!form || form.dataset.nvVolumeInitialized) return;
        form.dataset.nvVolumeInitialized = 'true';
        const input = Array.from(picker.querySelectorAll('input[data-option-position]')).find(item => item.value === this.dataset.optionValueId);
        if (!input || input.checked) return;
        const previous = picker.querySelector('input[data-option-position]:checked');
        input.checked = true;
        try {
          await picker.selectCombination({ optionValues: [input.value], productChange: false });
        } catch {
          input.checked = false;
          if (previous) previous.checked = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
